import Modal from "@mui/material/Modal";
import { Dispatch, ReactNode, SetStateAction, useCallback } from "react";
import { ReactComponent as CloseIcon } from "../../assets/General/close.svg";
import s from "./ModalWindow.module.css";

type ModalWindowProps = {
  children: ReactNode;
  isOpen: boolean;
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
  alternativeCloseFunction?: () => void;
  width?: string;
  height?: string;
  bgColor?: string;
  padding?: string;
  position?: "right" | "left" | "bottom";
  maxWidth?: string;
  borderRadius?: string;
  disableBackdropClick?: boolean;
  title?: string;
  headerMargin?: string;
  hiddenCloseBtn?: boolean;
};
const ModalWindow = ({
  children,
  isOpen,
  setIsOpen,
  alternativeCloseFunction,
  width,
  height,
  bgColor,
  padding,
  position,
  maxWidth,
  borderRadius = "20px",
  headerMargin = "0 0 20px 0",
  disableBackdropClick = false,
  title,
  hiddenCloseBtn = false,
}: ModalWindowProps) => {
  const closeModal = useCallback(() => {
    if (alternativeCloseFunction) {
      alternativeCloseFunction();
    } else if (setIsOpen) {
      setIsOpen(false);
    }
  }, [alternativeCloseFunction, setIsOpen]);

  return (
    <div style={{ outline: "none" }}>
      <Modal
        open={isOpen}
        onClose={(_, reason) => {
          if (disableBackdropClick && reason === "backdropClick") return;
          closeModal();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className={s.modal}
      >
        <div
          className={
            position === "right"
              ? s.modalContentRight
              : position === "left"
                ? s.modalContentLeft
                : position === "bottom"
                  ? s.modalContentBottom
                  : s.modalContent
          }
          style={{
            maxWidth: maxWidth ?? "auto",
            width: width ? width : "50%",
            height: height ? height : "fit-content",
            backgroundColor: bgColor ? bgColor : "rgb(27, 27, 27)",
            padding: padding
              ? padding
              : window.innerWidth > 768
                ? "20px"
                : "20px",
            borderRadius: borderRadius,
          }}
        >
          {!hiddenCloseBtn && (
            <div className={s.closeBtnBlock} style={{ margin: headerMargin }}>
              <div className={s.headTitle}>{title}</div>
              <div className={s.closeBtn} role="button" onClick={closeModal}>
                <CloseIcon className={s.whiteCloseIcon} />
              </div>
            </div>
          )}
          {children}
        </div>
      </Modal>
    </div>
  );
};
export default ModalWindow;
